export const PRODUCT_LOSS_LIMITS = 'product-loss-limit';
export const PRODUCT_BET_LIMITS = 'product-bet-limit';

export const UNLIMITED = '92233720368547758.07';

export const PRODUCT_ASCENDING_ERROR = 'playtech.mobile.system.tooltip.ascending.product';
